import { Button, IconNames, ButtonVariants } from "@triumph/design-system"
import { StyledActionButtonsContainer } from "../StyledComponents/TableHeaderStyledComponents"
import { useTranslation } from "react-i18next"

interface TableActionButtonsProps {
    onUpdatePaymentStatus?: () => void
    onBulkInvoiceDetails?: () => void
}

export const TableActionButtons = ({
    onUpdatePaymentStatus,
    onBulkInvoiceDetails,
}: TableActionButtonsProps) => {
    const { t } = useTranslation('invoicesDashboard', { keyPrefix: 'invoiceActionButtons' });
    return (
        <StyledActionButtonsContainer>
            <>
                <Button
                    variant={ButtonVariants.secondary}
                    icon={IconNames.Currency_Card}
                    iconLeft={true}
                    onClick={onUpdatePaymentStatus}
                >
                    {t("updateStatus")}
                </Button>
                <Button
                    variant={ButtonVariants.secondary}
                    icon={IconNames.Filetype_Invoice}
                    iconLeft={true}
                    onClick={onBulkInvoiceDetails}
                >
                    {t("invoiceDetails")}
                </Button>
            </>
        </StyledActionButtonsContainer>
    )
}
